import React from 'react';
import { Row, Col, Modal, Form } from 'react-bootstrap';
import Select from 'react-select';
import ExpandingTextArea from 'react-expanding-textarea';
import moment from 'moment';

// Services & Helpers
import BaseService from 'services/BaseService';
import TextHelpers from 'helpers/TextHelpers';
import GlobalStateService from 'services/GlobalStateService';
import InstructorService from 'services/InstructorService';
import LanguageService from 'services/LanguageService';
import CourseService from 'services/CourseService';
import CustomerService from 'services/CustomerService';
import JobRequestService from 'services/JobRequestService';
import UserService from 'services/UserService';
import LocationService from 'services/LocationService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';
import DatePicker from 'components/common/DatePicker';
import InstructorListModal from 'components/admin/InstructorListModal';

//-------------------------------------------------------------------------------------------------------------------

class AuditLogModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.resolve = resolve;
            this.loginInfo = GlobalStateService.getValue('loginInfo');

            this.setState({
                isOpen: true,
                isLoading: true,
                entityType: opts.entityType,
                entityID: opts.entityID,
                userID: opts.userID,
                year: new Date().getFullYear()
            }, () => {
                this.load();
            });
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async load() {
        const { entityType, entityID, userID, year } = this.state;
        this.setState({ isLoading: true });
        const auditEntries = await BaseService.callAPI('audit/get-log', {
            entityType,
            entityID,
            userID,
            year
        });
        this.setState({
            isLoading: false,
            auditEntries
        });
    }

    render() {
        const {
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="audit-log-modal">
                {this.renderInner()}
            </Modal>
        );
    }

    renderInner() {
        const {
            isLoading,
            auditEntries
        } = this.state;

        if (isLoading) {
            return (
                <Modal.Body>
                    <Loader />
                </Modal.Body>
            );
        }
        
        return (<>
            <div className="modal-header">
                <h5>Audit log</h5>
                <button type="button" className="btn btn-secondary ms-auto ms-auto" onClick={() => this.close()}>
                    Close
                </button>
            </div>
            <Modal.Body>
                <div className="sticky-table-container scrolling">
                    <table className="table table-bordered sticky-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Time (UTC)</th>
                                <th>Item</th>
                                <th>Sub-item</th>
                                <th>User</th>
                                <th>Action</th>
                                <th>Field</th>
                                <th>Old value</th>
                                <th>New value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {auditEntries.map(ae => this.renderAuditEntry(ae))}
                            {auditEntries.length == 0 &&
                                <tr>
                                    <td colspan="9" className="empty-text">
                                        No audit information available
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
        </>);
    }

    renderAuditEntry(entry) {
        // TODO hide entity if we are looking at a specific entity
        const changes = entry.changes.filter(c =>
            (c.oldValue || c.newValue) && c.newValue != c.oldValue
        );
        return changes.map((change, index) =>
            <tr key={change.id} data-id={`${entry.id}-${change.id}`}>
                {index == 0 && <>
                    <td rowSpan={changes.length}>{moment(entry.date).format('DD/MM/YYYY')}</td>
                    <td rowSpan={changes.length}>{moment(entry.date).format('HH:mm:ss')}</td>
                    <td rowSpan={changes.length}>{this.renderEntity(entry.entityType, entry.entity)}</td>
                    <td rowSpan={changes.length}>TODO</td>
                    <td rowSpan={changes.length}>{entry.user ? TextHelpers.formatName(entry.user.firstName, entry.user.lastName) : null}</td>
                    <td rowSpan={changes.length}>{entry.code}</td>
                </>}
                <td>{change.field}</td>
                <td>
                    {entry.code == 'Add' ? '' : this.formatValue(entry.entityType, change.field, change.oldValue)}
                </td>
                <td>{this.formatValue(entry.entityType, change.field, change.newValue)}</td>
            </tr>
        ); 
    }

    renderEntity(entityType, entity) {
        if (!entity) return null;
        switch (entityType || '') {
            case 'Instructor':
                return TextHelpers.formatInstructorName(entity);
                // TODO other entity types
        }
        return null;
    }

    formatValue(entityType, fieldName, value) {
        if (!value) return null;
        let dataType;
        if (fieldName.indexOf('Is') == 0) {
            dataType = 'bool';
        } else {
            switch (entityType || '') {
                case 'Instructor':
                    switch (fieldName) {
                        case 'Signature':
                            return (<img src={value} style={{ maxWidth: 200 }} />);
                        case 'StandardCostRate':
                        case 'ChampionCostRate':
                            dataType = 'currency';
                            break;
                        case 'StartDate':
                        case 'ExpiryDate':
                        case 'DateExamPassed':
                        case 'OnboardDate':
                        case 'GoLiveDate':
                            dataType = 'date';
                            break;
                    }
            }
        }
        switch (dataType) {
            case 'bool':
                if (value.toLowerCase() == 'true') return 'Yes';
                else if (value.toLowerCase() == 'false') return 'No';
                else return null;
            case 'currency':
                return TextHelpers.formatCurrencyNew(value);
            case 'date':
                const dateMoment = moment(value, 'DD/MM/YYYY HH:mm:ss');
                if (dateMoment.isValid()) {
                    return dateMoment.format('DD/MM/YYYY');
                }
        }
        return value;
    }
}

export default AuditLogModal;